export const disabledFlagStyle = {
  filter: "grayscale(50%)",
  opacity: 0.5,
};

export { default as DeFlagIcon } from "./deFlag";
export { default as DevFlagIcon } from "./devFlag";
export { default as FrFlagIcon } from "./frFlag";
export { default as UkFlagIcon } from "./ukFlag";
